import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import moment from 'moment';
import {Moment} from 'moment';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDatepicker} from '@angular/material/datepicker';
import {MAT_DATE_FORMATS} from '@angular/material/core';
import {MaandJaar} from '../../core/date/maand-jaar';
import {ExportOption} from '../export-option';

@Component({
    selector: 'zah-exports',
    templateUrl: './exports.component.html',
    styleUrls: ['./exports.component.scss'],
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'MM/YYYY',
                },
                display: {
                    dateInput: 'MM/YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                }
            }
        },
    ],
    standalone: false
})
export class ExportsComponent implements OnInit {

  exportOptions: Array<ExportOption> = [ExportOption.PRESTATIECIJFER, ExportOption.TAAKCIJFER, ExportOption.ACTIVITEITCIJFER];
  @Output()
  downloadClicked: EventEmitter<[ExportOption, MaandJaar]> = new EventEmitter<[ExportOption, MaandJaar]>();

  private now: Moment = moment();
  private maand: number = this.now.month();
  private jaar: number = this.now.year();
  maandJaarForm: FormGroup;
  maandJaarPlaceholder: string = this.now.format('MM/YYYY');

  ngOnInit(): void {
    this.maandJaarForm = new FormGroup({
      exportOption: new FormControl(ExportOption.PRESTATIECIJFER, Validators.required),
      maandJaar: new FormControl(this.now, Validators.required),
    });
  }

  get exportOption(): AbstractControl {
    return this.maandJaarForm.controls.exportOption;
  }

  get maandJaar(): AbstractControl {
    return this.maandJaarForm.controls.maandJaar;
  }

  onYearSelected(normalizedYear: Moment): void {
    this.jaar = normalizedYear.year();
    const ctrlValue = this.maandJaar.value;
    ctrlValue.year(this.jaar);
    this.maandJaar.setValue(ctrlValue);
  }

  onMontSelected(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>): void {
    this.maand = normalizedMonth.month();
    this.jaar = normalizedMonth.year();
    const ctrlValue = this.maandJaar.value;
    ctrlValue.month(this.maand);
    ctrlValue.year(this.jaar);
    this.maandJaar.setValue(ctrlValue);
    datepicker.close();
  }

  onDownloadClick(): void {
    this.downloadClicked.emit([this.exportOption.value, new MaandJaar(this.maand + 1, this.jaar)]);
  }
}
